export default {
  heading: 'Bebas Neue, sans-serif',
  body: 'Raleway, sans-serif',
  monospace: 'Menlo, monospace',
  display: 'Lobster, cursive',
  googleFonts: ['Raleway:100,200,300,400,500,600,700,800,900', 'Bebas Neue', 'Lobster']
  // customFamilies: [''],
  // customUrls: [''],
}
